let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f2uDI")).then(() => parcelRequire('3deqg'));